import { render, staticRenderFns } from "./AttributesSelector.vue?vue&type=template&id=070c857f&scoped=true"
import script from "./AttributesSelector.vue?vue&type=script&lang=ts"
export * from "./AttributesSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070c857f",
  null
  
)

export default component.exports